/// <amd-module name="TFS/Admin/Common/Contracts/CustomIdentityRef" />
export interface ICustomIdentityRef {
    id: string;
    imageUrl?: string;
    displayName: string;
    preferredEmailAddress?: string;
    isUser?: boolean;
    descriptor?: string;
}
